const cities = [
  { name: "Broken Arrow", zips: "74011, 74012, 74014" },
  { name: "Bixby", zips: "74008" },
  { name: "Jenks", zips: "74037" },
  { name: "Coweta", zips: "74429" },
  { name: "Wagoner", zips: "74467" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home, office, or campus in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function BrokenArrowLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Broken Arrow &amp; Tulsa East Metro
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Broken Arrow is the fourth-largest city in Oklahoma with over 120,000 residents. Located just southeast of Tulsa, it is one of the fastest-growing cities in the state and serves as a hub for young families, faith communities, and the growing Tulsa east metro business district. The city's strong sense of community, excellent schools, and affordable cost of living have attracted thousands of new residents over the past decade — many of whom discover passport needs for the first time as they plan mission trips, family vacations, and international travel.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">The Rose District &amp; Downtown BA:</strong> Broken Arrow's revitalized downtown features a vibrant arts district, restaurants, and boutique shops. The community's strong faith culture drives significant demand for mission trip travel to Latin America, Africa, and Southeast Asia. Many Rose District residents are young professionals who travel for business conferences and international leisure. The district's mix of historic charm and modern development reflects the broader Broken Arrow story — a city that honors its roots while looking outward to the world.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Faith Communities &amp; Mission Travel:</strong> Broken Arrow has one of the highest concentrations of evangelical churches per capita in Oklahoma. Church mission trips to Guatemala, Honduras, Costa Rica, and Jamaica generate group passport demand throughout the year, with peaks in June and July. Youth group travel requires coordination of child passports with parental consent — an area where our guidance is especially valuable. Group leaders often finalize rosters 4–6 weeks before departure, then discover that multiple passports have expired or that children have never had one. We coordinate group processing and child passport requirements to keep entire mission teams on schedule.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">NSU Broken Arrow Campus:</strong> Northeastern State University's Broken Arrow campus serves thousands of students in nursing, education, and business programs. International students and those participating in exchange programs need passport services for both U.S. re-entry and international travel. Study-abroad deadlines create predictable spikes in first-time passport demand in spring and fall. NSU-BA students often discover their passport issues after they are accepted into a program, leaving them with weeks rather than months to resolve what might otherwise be a routine renewal or first-time application.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Coweta, Wagoner &amp; Catoosa:</strong> These neighboring communities rely on Broken Arrow for passport services. Many residents work in Tulsa or BA and need passport services that fit their schedules without requiring multiple facility visits. The Tulsa east metro is tightly connected — a church in Coweta might have members in Wagoner, Bixby, and Broken Arrow all joining the same mission trip. Our remote service model covers the entire east metro area without requiring anyone to drive to Oklahoma City.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Whether you are a Broken Arrow family heading on a mission trip to Guatemala, a young professional traveling to Singapore for business, a BA athlete competing internationally, or a retiree planning a European cruise, we provide fast and reliable passport services tailored to your needs. Our registered courier delivers directly to the State Department — no mailing delays. Ship from any UPS or FedEx location in Broken Arrow, Bixby, or Jenks and we handle the rest.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Broken Arrow, OK</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving all of Tulsa East Metro remotely</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — serving Broken Arrow, Bixby, Jenks, Coweta &amp; Wagoner
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Ship your documents overnight from anywhere in the Tulsa east metro</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, ship your documents with our <strong className="text-white">prepaid overnight label</strong> from any UPS or FedEx location in Broken Arrow. Most clients never need to visit an office — just start online, ship overnight, and we handle the rest.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline truncate ml-2 max-w-[160px]">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in the Tulsa east metro — start online, ship overnight, and we handle the rest. No need to drive to Oklahoma City for regional agency appointments.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Tulsa", href: "/tulsa" },
                    { name: "Oklahoma City", href: "/oklahoma-city" },
                    { name: "Norman", href: "/norman" },
                    { name: "Edmond", href: "/edmond-ok" },
                    { name: "Bixby", href: "/broken-arrow" },
                    { name: "Jenks", href: "/tulsa" },
                  ].map((link) => (
                    <a
                      key={link.href + link.name}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Broken Arrow Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}